export { default } from "./DynamicContent";
